// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_lf-0";